export const PricingPriceCalcSchemaPluginSettings: IPluginSettings = {
    name: 'Схема расчёта цен',
    mnemocode: 'pricing_price_calc_schema_plugin',
    permission: 'Pricing',
    columns: [
        {
            order: 0,
            propertyName: 'idGlobal',
            propertyType: 'string',
            displayName: 'ID вида шкалы наценок',
            visibility: false,
            width: 150
        },
        {
            order: 1,
            propertyName: 'idPricingPriceCalcSchemaGlobal',
            propertyType: 'string',
            displayName: 'ID минимальной наценки',
            visibility: false,
            width: 200
        },
        {
            order: 2,
            propertyName: 'name',
            propertyType: 'string',
            displayName: 'Наименование',
            visibility: true,
            width: 200
        },
        {
            order: 3,
            propertyName: 'description',
            propertyType: 'string',
            displayName: 'Описание',
            visibility: true,
            width: 200
        },
        {
            order: 4,
            propertyName: 'conditionMethod',
            propertyType: 'string',
            displayName: 'Объединение условий',
            visibility: true,
            width: 70
        },
        {
            order: 5,
            propertyName: 'dateCreated',
            propertyType: 'datetime',
            displayName: 'Дата создания',
            visibility: false,
            width: 200
        },
        {
            order: 6,
            propertyName: 'dateModified',
            propertyType: 'datetime',
            displayName: 'Дата последнего изменения',
            visibility: false,
            width: 200
        },
        {
            order: 7,
            propertyName: 'dateDeleted',
            propertyType: 'datetime',
            displayName: 'Дата удаления',
            visibility: false,
            width: 200
        },

    ],
}